import type { PropsWithChildren } from 'react';

/**
 * Pane header. Must be used inside Pane. Thin wrapper around ContainerHeader.
 */
import { forwardRef } from 'react';

import {
  ContainerHeader,
  type ContainerHeaderProps,
} from '@frontend/legacy-components';

export type PaneHeaderProps = PropsWithChildren<unknown> &
  Omit<ContainerHeaderProps, 'children'>;

export const PaneHeader = forwardRef<HTMLDivElement, PaneHeaderProps>(
  ({ children, ...props }, ref) => (
    <ContainerHeader
      ref={ref}
      px={2}
      py={1.25}
      alignItems="center"
      justifyContent="space-between"
      flexWrap="wrap"
      gap={1}
      {...props}
    >
      {children}
    </ContainerHeader>
  ),
);

PaneHeader.displayName = 'PaneHeader';
